export default "__VITE_ASSET__BH33kiSL__"